<template>
  <div  style="width: 100%;height: 100%">
    <el-scrollbar style="height: 100%">
      <div style="text-align: center;font-size: 26px;font-weight: bolder;margin-bottom: 1%">推荐单位意见</div>
      <el-form ref="form" :model="projectData" :rules="rules">
        <div style="width: 90%;border: 1px solid #000000;margin-left: 5%;padding: 20px;background-color: #ffffff">
          <div>本项目主要科技支撑材料有：</div>
          <div style="margin-top: 8px;">（1）发明专利
            <el-form-item prop="invent">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.invent" class="input_text" @input="(val)=>{projectData.invent = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项（附件编号
            <el-form-item prop="adjunct1">
              <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct1" class="input_text"></el-input>
            </el-form-item>），满1年以上的
            <el-form-item prop="deadline1">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline1" class="input_text" @input="(val)=>{projectData.deadline1 = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项；
          </div>
          <div>（2）实用新型专利
            <el-form-item prop="nowtype">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.nowtype" class="input_text" @input="(val)=>{projectData.nowtype = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项（附件编号
            <el-form-item prop="adjunct2">
              <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct2" class="input_text"></el-input>
            </el-form-item>），满1年以上的
            <el-form-item prop="deadline2">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline2" class="input_text" @input="(val)=>{projectData.deadline2 = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项；</div>
          <div>（3）编制标准
            <el-form-item prop="standard">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.standard" class="input_text" @input="(val)=>{projectData.standard = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项，其中国家（行业）标准
            <el-form-item prop="countrystandard">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.countrystandard" class="input_text" @input="(val)=>{projectData.countrystandard = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项（附件编号
            <el-form-item prop="adjunct31">
              <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct31" class="input_text"></el-input>
            </el-form-item>），满一年以上的
            <el-form-item prop="deadline31">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline31" class="input_text" @input="(val)=>{projectData.deadline31 = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项；地方标准
            <el-form-item prop="spacestandard">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.spacestandard" class="input_text" @input="(val)=>{projectData.spacestandard = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项（附件编号
            <el-form-item prop="adjunct32">
              <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct32" class="input_text"></el-input>
            </el-form-item>），满一年以上的
            <el-form-item prop="deadline32">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline32" class="input_text" @input="(val)=>{projectData.deadline32 = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项；
          </div>
          <div>（4）软件著作权
            <el-form-item prop="copyright">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.copyright" class="input_text" @input="(val)=>{projectData.copyright = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项（附件编号
            <el-form-item prop="adjunct4">
              <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct4" class="input_text"></el-input>
            </el-form-item>），满1年以上的
            <el-form-item prop="deadline4">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline4" class="input_text" @input="(val)=>{projectData.deadline4 = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项；</div>
          <div>（5）SCI论文
            <el-form-item prop="scipaper">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.scipaper" class="input_text" @input="(val)=>{projectData.scipaper = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>篇（附件编号
            <el-form-item prop="adjunctsci">
              <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunctsci" class="input_text"></el-input>
            </el-form-item>），满1年以上的
            <el-form-item prop="deadline5">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline5" class="input_text" @input="(val)=>{projectData.deadline5 = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>篇；</div>
          <div>（6）EI论文
            <el-form-item prop="eipaper">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.eipaper" class="input_text" @input="(val)=>{projectData.eipaper = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>篇（附件编号
            <el-form-item prop="adjunctei">
              <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunctei" class="input_text"></el-input>
            </el-form-item>），满1年以上的
            <el-form-item prop="deadline6">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.deadline6" class="input_text" @input="(val)=>{projectData.deadline6 = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>篇；</div>
          <div>（7）核心期刊论文
            <el-form-item prop="corejournal">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.corejournal" class="input_text" @input="(val)=>{projectData.corejournal = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>篇（附件编号
            <el-form-item prop="adjunctcore">
              <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunctcore" class="input_text"></el-input>
            </el-form-item>），其中中文核心
            <el-form-item prop="chinesecore">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.chinesecore" class="input_text" @input="(val)=>{projectData.chinesecore = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>篇，科技核心
            <el-form-item prop="sciencecore">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.sciencecore" class="input_text" @input="(val)=>{projectData.sciencecore = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>篇；</div>
          <div>（8）近三年主要经济效益
            <el-form-item prop="benefit">
              <el-input :readonly="isDisabled" size="small" style="width: 100px" v-model="projectData.benefit" class="input_text" @input="(val)=>{projectData.benefit = limitDecimalInputWithDigit(val, 4)}"></el-input>
            </el-form-item>万元（旁证材料见附件编号
            <el-form-item prop="adjunctbenefit">
              <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunctbenefit" class="input_text"></el-input>
            </el-form-item>）；</div>
          <div>（9）已在
            <el-form-item prop="promotion">
              <el-input :readonly="isDisabled" size="small" style="width: 100px" v-model="projectData.promotion" class="input_text"></el-input>
            </el-form-item>范围内推广应用，并产生了显著的社会效益（旁证材料见附件编号
            <el-form-item prop="adjunctpromotion">
              <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunctpromotion" class="input_text"></el-input>
            </el-form-item>）；</div>
          <div>（10）其它
            <el-form-item prop="others">
              <el-input :readonly="isDisabled" size="small" style="width: 100px" v-model="projectData.others" class="input_text" @input="(val)=>{projectData.others = val.replace(/[^\d:]/g, '')}"></el-input>
            </el-form-item>项（附件编号
            <el-form-item prop="adjunct5">
              <el-input :readonly="isDisabled" size="small" style="width: 200px" v-model="projectData.adjunct5" class="input_text"></el-input>
            </el-form-item>）。
          </div>
          <div><br/>推荐意见（限300字）：</div>
          <el-form-item prop="opinion" style="width: 100%">
            <el-input :readonly="isDisabled" size="small" style="width: 100%;margin-top: 10px;" type="textarea" :autosize="{minRows:6}" v-model="projectData.opinion" maxlength="300" show-word-limit></el-input>
          </el-form-item>
          <div><br/>本项目满足申请省交通运输科学技术进步
            <el-form-item prop="declare1">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.declare1" class="input_text"></el-input>
            </el-form-item>等奖条件，推荐本项目申请省交通运输科学技术进步
            <el-form-item prop="declare2">
              <el-input :readonly="isDisabled" size="small" style="width: 50px" v-model="projectData.declare2" class="input_text"></el-input>
            </el-form-item>等奖。</div>
        </div>
        <div style="width: 90%;border: 1px solid #000000;margin-left: 5%;padding: 20px;border-top: none;background-color: #ffffff">
          <div><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;声明：</strong>本单位遵守《河南省交通运输科学技术进步奖管理办法》等有关规定和要求，对推荐书内容及全部附件材料进行了严格审查，并进行了原件审查工作，保证所推荐项目的全部推荐材料真实有效，确认该项目符合推荐资格条件，项目完成人及完成单位排序无异议，且不存在任何违反《中华人民共和国保守国家秘密法》和《科学技术保密规定》等相关法律法规及侵犯他人知识产权的情形。如有材料虚假或违纪行为，愿意承担相应责任并接受相应处理。如产生争议，保证积极配合调查处理工作。
            <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我单位承诺将严格按照河南省公路学会的有关规定和要求，认真履行作为推荐单位的义务并承担相应的责任。
          </div>
        </div>
        <div v-if="!isDisabled" style="width: 100%;margin-top: 20px;">
          <el-button type="info" @click="onReset" style="margin-left: 46%">重置</el-button>
          <el-button type="primary" @click="onSubmit" :disabled="isDisabledSubmit">保存</el-button>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
  import utils from "../../js/utils";

  export default {
  name: "RecommendOpinions_11",
    data() {
      return {
        createuserid: sessionStorage.getItem('createuserid'),
        isDisabled: sessionStorage.getItem('openWith') == 'readOnly' ? true : false,
        projectData: {
          pbcid: Number(sessionStorage.getItem('pbcid')),
          invent: '',
          adjunct1: '',
          deadline1: '',
          nowtype: '',
          adjunct2: '',
          deadline2: '',
          standard: '',
          countrystandard: '',
          adjunct31: '',
          deadline31: '',
          spacestandard: '',
          adjunct32: '',
          deadline32: '',
          copyright: '',
          adjunct4: '',
          deadline4: '',
          scipaper: '',
          deadline5: '',
          eipaper: '',
          deadline6: '',
          corejournal: '',
          chinesecore: '',
          sciencecore: '',
          benefit: '',
          promotion: '',
          others: '',
          adjunct5: '',
          opinion: '',
          declare1: '',
          declare2: '',
          adjunctsci: '',
          adjunctei: '',
          adjunctcore: '',
          adjunctbenefit: '',
          adjunctpromotion: '',
        },
        rules: {
          invent: {required: true, message: ' ', trigger: 'blur'},
          deadline1: {required: true, message: ' ', trigger: 'blur'},
          nowtype: {required: true, message: ' ', trigger: 'blur'},
          deadline2: {required: true, message: ' ', trigger: 'blur'},
          standard: {required: true, message: ' ', trigger: 'blur'},
          countrystandard: {required: true, message: ' ', trigger: 'blur'},
          deadline31: {required: true, message: ' ', trigger: 'blur'},
          spacestandard: {required: true, message: ' ', trigger: 'blur'},
          deadline32: {required: true, message: ' ', trigger: 'blur'},
          copyright: {required: true, message: ' ', trigger: 'blur'},
          deadline4: {required: true, message: ' ', trigger: 'blur'},
          scipaper: {required: true, message: ' ', trigger: 'blur'},
          deadline5: {required: true, message: ' ', trigger: 'blur'},
          eipaper: {required: true, message: ' ', trigger: 'blur'},
          deadline6: {required: true, message: ' ', trigger: 'blur'},
          corejournal: {required: true, message: ' ', trigger: 'blur'},
          chinesecore: {required: true, message: ' ', trigger: 'blur'},
          sciencecore: {required: true, message: ' ', trigger: 'blur'},
          benefit: {required: true, message: ' ', trigger: 'blur'},
          others: {required: true, message: ' ', trigger: 'blur'},
        },
        isDisabledSubmit:false
      }
    },
    methods: {
      getData() {
        this.$axios({
          method: 'get',
          url: this.GLOBAL.URL + 'pingjiang/common/selectprojectopinion',
          params: {
            pbcid: Number(sessionStorage.getItem('pbcid')),
            opiniontype:0
          }
        }).then(res => {
          let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
          if (resp.code == 1000) {
            if(resp.data!=null){
              this.projectData = resp.data;
              // this.isDisabledSubmit=false
              this.closeLoading()
            }
          } else {
            this.showFailMsg(resp.message)
            // this.isDisabledSubmit=false
            this.closeLoading()
          }
        })
      },
      onSubmit() {
        // this.isDisabledSubmit=true
        this.projectData.opiniontype=0
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.openLoading("内容提交中","提交失败，请检查网络",7000)
            let url = '';
            url = this.projectData.oid==undefined?'pingjiang/user/addprojectopinion':'pingjiang/user/updateprojectopinion';
            this.$axios({
              method: 'post',
              url: this.GLOBAL.URL + url,
              data: this.projectData
            }).then((res) => {
              let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
              if (resp.code == 1000) {
                this.showSuccessMsg(resp.message);
                this.getData()
              } else {
                this.closeLoading()
                this.showFailMsg(resp.message);
                // this.isDisabledSubmit=false
              }
            })
          } else {
            this.showNotifyError('请先完善信息！');
          }
        })
      },
      onReset(){
        Object.assign(this.projectData, this.$options.data().projectData)
      },
    },
    created() {
      this.getData()
    },
    mounted() {
      if(sessionStorage.getItem('pbcid')==undefined){
        this.$message.error('请先填写项目基本情况表');
        this.$router.push({
          path:'/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01'
        })
      }
    }
}
</script>

<style scoped>
  /deep/ .el-scrollbar__wrap {
    overflow: hidden scroll;
    height: 100%;
  }

  /deep/ .input_text .el-input__inner{
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
    padding: 0 3px;
    height: 16px;
    text-align: center;
  }

  .el-form-item {
    display: inline-block;
    margin-bottom: 0;
  }

  /deep/ .el-form-item__content{
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/PJGL/ProjectSequence/RecommendOpinions_11.vue